"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const downshift_1 = __importDefault(require("downshift"));
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const List_1 = __importDefault(require("@mui/material/List"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const utils_1 = require("utils/utils");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const MaterialCombobox = (props) => {
    const { width = 'auto', marginProp = 'none' } = props;
    const { classes } = useStyles();
    const [initialValue, setInitialValue] = (0, react_1.useState)(props.value);
    const prevPropsValue = (0, react_use_1.usePrevious)(props.value);
    let target;
    const updateInputValue = (event) => {
        if (props.onChangeInput) {
            props.onChangeInput(event);
            setInitialValue(null);
        }
    };
    const stateReducer = (state, changes) => {
        switch (changes.type) {
            case '__autocomplete_click_item__':
            case '__autocomplete_blur_input__':
                if (state.selectedItem) {
                    return Object.assign(Object.assign({}, changes), { inputValue: null });
                }
                break;
            default:
                return changes;
        }
        return changes;
    };
    const itemChange = (e) => {
        if (props.onChange) {
            props.onChange(e);
        }
        if (target) {
            target.select();
        }
    };
    const handleFocus = (e) => {
        e.target.select();
        target = e.target;
    };
    const keyDown = (e, newItems) => {
        if (e.key === 'Escape') {
            setInitialValue(props.value);
        }
        if (e.key === 'Tab') {
            if (newItems && Math.max((0, utils_1.noNaN)(newItems.size), (0, utils_1.noNaN)(newItems.length)) > 0) {
                // TODO: keeping this alread commented code, need to check the reason.
                /*
                  const event = new KeyboardEvent('keydown', {
                    key: 'Enter',
                    keyCode: 13,
                    bubbles: true,
                    cancelable: true,
                  });
                  this.target.dispatchEvent(event);
                  this.itemChange(items.get('0'));
                */
            }
        }
        else if (props.onKeyDown) {
            props.onKeyDown(e);
        }
    };
    function autoCompleteContents({ getInputProps, getItemProps, highlightedIndex, inputValue, isOpen, selectHighlightedItem, selectedItem, }) {
        function autoCompleteItemToHtml(item, index) {
            let selected = false;
            if (selectedItem) {
                if (item.id && selectedItem.id) {
                    selected = item.id === selectedItem.id;
                }
            }
            const itemProps = getItemProps({
                item,
                index,
                dataHighlighted: highlightedIndex === index,
                dataSelected: selected,
                onClick: () => {
                    selectHighlightedItem();
                },
            });
            let stateColor = 'rgba(0,0,0,0)';
            if (itemProps.dataHighlighted) {
                stateColor = 'rgba(0,0,0,0.12)';
            }
            if (itemProps.dataSelected) {
                stateColor = 'rgba(0,0,0,0.0)';
            }
            return props.displayTemplate
                ? props.displayTemplate(item, itemProps, inputValue)
                : (<ListItem_1.default {...itemProps} style={{
                        backgroundColor: stateColor,
                    }}>
            <ListItemText_1.default primary={`${item}`}/>
          </ListItem_1.default>);
        }
        function valuesBySearchTerm(item) {
            var _a;
            const currentVal = inputValue || '';
            if (!currentVal) {
                return true;
            }
            const searchThis = props.searchTemplate
                ? (_a = props.searchTemplate(item)) === null || _a === void 0 ? void 0 : _a.toLowerCase()
                : item.toString();
            return searchThis.indexOf(currentVal === null || currentVal === void 0 ? void 0 : currentVal.toLowerCase()) === 0;
        }
        let filteredItems = [];
        let autoCompleteMenuItems = [];
        if (isOpen) {
            filteredItems = props.items.filter(valuesBySearchTerm);
            // @ts-expect-error - FIXME:
            autoCompleteMenuItems = filteredItems.map(autoCompleteItemToHtml);
            if (props.onListChange) {
                props.onListChange(filteredItems);
            }
        }
        const autoCompleteMenu = (<div className={classes.menuAnchor}>
        <List_1.default className={classes.listContainer} sx={Object.assign({}, (props.menuPosition && { position: props.menuPosition }))}>
          {autoCompleteMenuItems}
        </List_1.default>
      </div>);
        const value = inputValue || initialValue || '';
        const inputProps = getInputProps({
            placeholder: props.placeholder || '',
            value,
            className: props.textFieldVariant === 'outlined' ? '' : classes.inputField,
            label: props.label,
            onChange: updateInputValue,
            autoFocus: true,
            onFocus: handleFocus,
            onKeyDown: (e) => keyDown(e, filteredItems),
            name: props.name,
            // padding added directly to the right input to accommodate the menu icon
            InputProps: Object.assign({ inputProps: {
                    ref: props.inputRef,
                    style: { fontSize: props.fontSize || '13px', paddingRight: 6, minHeight: 23 },
                    'aria-label': 'Payee Field',
                }, onBlur: props.onBlur }, (props.textFieldVariant !== 'outlined' && { disableUnderline: props.disableUnderline })),
        });
        const retItems = [];
        retItems.push(<div className={classes.frame}>
        <Box_1.default className={classes.inputFrame} width={width}>
          <TextField_1.default variant={props.textFieldVariant} margin={marginProp} {...props.textFieldProps} {...inputProps} fullWidth/>
        </Box_1.default>
        <div className={classes.menuFrame}>
          {isOpen ? autoCompleteMenu : null}
        </div>
      </div>);
        return retItems;
    }
    (0, react_1.useEffect)(() => {
        if (props.value !== prevPropsValue) {
            setInitialValue(props.value);
        }
    }, [props.value, prevPropsValue]);
    return (<downshift_1.default {...props} stateReducer={stateReducer} 
    // @ts-expect-error TS() - FIXME: some event handler type issue with Downshift component
    onChange={itemChange} itemToString={props.inputDisplayTemplate}>
      {autoCompleteContents.bind(this)}
    </downshift_1.default>);
};
exports.default = react_1.default.memo(MaterialCombobox);
